import React, { Component } from 'react';

class Loading extends Component {
  render() {
    return <div></div>;
  }
}

export default Loading;
